"use client";

import "@/lib/firebase/config"; // firebase初期化を走らせるためにimportする
import { firebaseAuth } from "@/lib/firebase/config";
import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { readUser } from "~/src/lib/firestore/user";
import {
  AuthContext,
  AuthSetContext,
  USER_AUTH_INIT,
  UserAuthInfo,
  UserAuthState,
} from "~/src/stores/context/auth/AuthContext";

export type AuthProviderProps = {
  children: React.ReactNode;
};

/**
 * 認証Provider
 */
export default function AuthProvider({ children }: AuthProviderProps) {
  // ユーザー認証情報
  const [user, setUser] = useState<UserAuthState>(USER_AUTH_INIT);
  const [userInfo, setUserInfo] = useState<UserAuthInfo>(undefined);

  // console.log("AuthProvider 動作チェック 先頭");

  /**
   * コンポーネントマウント時処理
   */
  useEffect(() => {
    try {
      //------------
      // ユーザー情報取得
      //------------
      const getUserInfo = async (user: UserAuthState) => {
        //------------
        // 未ログイン
        //------------
        if (!user) return;

        //------------
        // ログイン中
        //------------
        const info = await readUser(user.uid);
        setUserInfo(info);
      };

      //------------
      // ユーザー認証オブザーバ（認証状態の監視）をたてる
      //------------
      // 情報に変更があった時、ユーザー情報を再設定
      const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
        console.log("AuthProvider 認証変更検出 user=", user);

        //------------
        // 設定
        //------------
        setUser(user);
        getUserInfo(user);
      });

      // アンマウント時には、監視を解除する
      return unsubscribe;
    } catch (error) {
      //------------
      // エラー時
      //------------
      // ユーザー情報初期化
      setUser(USER_AUTH_INIT);

      console.log("AuthProvider 動作チェック エラールート error=", error);

      // throw error;
    }
  }, []);

  // console.log("AuthProvider 動作チェック レンダリング直前 user=", user);

  return (
    <AuthContext.Provider
      value={{
        user: user,
        info: userInfo,
      }}
    >
      <AuthSetContext.Provider
        value={{
          setUser: setUser,
          setInfo: setUserInfo,
        }}
      >
        {children}
      </AuthSetContext.Provider>
    </AuthContext.Provider>
  );
}
